import { useCallback } from 'react';
import {
	useAnalyticsEvents,
	fireOperationalAnalytics,
	fireTrackAnalytics,
} from '@atlassian/jira-product-analytics-bridge';

type AnalyticsAttributes = Record<string, string | number | boolean | undefined | object>;

type FireAnalyticEventProps = {
	event: 'track' | 'operational';
	action: 'linked' | 'linked-failed' | 'unlinked' | 'unlinked-failed';
	actionSubject?: string;
	analyticsAttributes: AnalyticsAttributes;
};

const DEFAULT_ACTION_SUBJECT = 'project';

export const useAtlasProjectAnalyticsEvent = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const fireAtlasProjectAnalyticsEvent = useCallback(
		({
			event,
			analyticsAttributes,
			action,
			actionSubject = DEFAULT_ACTION_SUBJECT,
		}: FireAnalyticEventProps) => {
			if (event === 'operational') {
				fireOperationalAnalytics(
					createAnalyticsEvent({}),
					`${actionSubject} ${action}`,
					analyticsAttributes,
				);

				return;
			}

			fireTrackAnalytics(
				createAnalyticsEvent({}),
				`${actionSubject} ${action}`,
				analyticsAttributes,
			);
		},
		[createAnalyticsEvent],
	);

	return {
		fireAtlasProjectAnalyticsEvent,
	};
};
